export default class DtoPiezometerReferent {
    constructor(obj = {}) {
        this.idStation = obj.idStation
        this.idContributor = obj.idContributor
        this.code = obj.code
        this.name = obj.name
        this.contributorType = obj.contributorType
    }
}